// All HLR (Half-Life Regression) logic - unchanged from original

export const NOW = () => Date.now() / 3600000; // hours since epoch

export function recallProbability(word, now = NOW()) {
  if (!word || !word.lastReviewTime) return 1;
  const delta = Math.max(0, now - word.lastReviewTime);
  return Math.exp(-delta / Math.max(word.halfLife, 0.1));
}

export function updateHalfLife(word, correct) {
  const acc = word.correctCount / (word.correctCount + word.incorrectCount + 1);
  return correct
    ? word.halfLife * (1 + 0.3 + acc)
    : Math.max(0.5, word.halfLife * 0.5);
}

export function hoursUntilForgotten(word) {
  return Math.max(0, -word.halfLife * Math.log(0.5));
}

export function getStatus(word) {
  if (!word || !word.lastReviewTime) return "New";
  const p = recallProbability(word);
  if (p >= 0.75) return "Strong";
  if (p >= 0.4)  return "At Risk";
  return "Weak";
}

export function selectWordFromPool(wordStates) {
  const now = NOW();
  const withP = wordStates.map((w) => ({
    ...w,
    p: w.lastReviewTime ? recallProbability(w, now) : -1,
  }));
  const newWords = withP.filter((w) => w.p === -1);
  if (newWords.length > 0)
    return newWords[Math.floor(Math.random() * Math.min(2, newWords.length))];
  withP.sort((a, b) => a.p - b.p);
  const pool = withP.slice(0, Math.max(1, Math.ceil(withP.length * 0.25)));
  return pool[Math.floor(Math.random() * pool.length)];
}

export function getXP(correct, streak, halfLife) {
  if (!correct) return 0;
  return 10 + Math.min(streak, 10) * 2 + (halfLife < 2 ? 5 : 0);
}

export function getLevel(xp) { return Math.floor(Math.sqrt(xp / 50)) + 1; }
export function xpForLevel(lvl) { return lvl * lvl * 50; }

export function formatForgottenTime(hrs) {
  if (hrs < 1)  return `${Math.round(hrs * 60)}m`;
  if (hrs < 48) return `${hrs.toFixed(1)}h`;
  return `${(hrs / 24).toFixed(1)}d`;
}
